<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext pb-55">
      <div class="container pb-0">
        <div class="area_wrap">
          <div class="text_wrap caution">
            <div class="tw_item">
              <div class="tw_title">
                <h2>수술 예약 환자 입원 안내</h2>
                <span>(2023년 5월 기준. 병원 사정에 따라 변경될 수 있습니다.)</span>
                <!--                <p>★ 코로나 바이러스 유행으로 보호자는 1명으로 제한합니다. (당분간 면회 금지) ★</p>-->
                <p>
                  <span class="red">* 수술 당일 6층 입원실로 오세요.</span>
                  <br/>(3호기 승강기 이용)*
                </p>
              </div>
            </div>
            <div class="tw_item">
              <div class="tw_title">
                <h2>입원시 준비 물품</h2>
              </div>
              <div class="tw_content another">
                <p>물컵, 물통, 세면도구(수건 포함) 등 개인용품(치약, 칫솔 포함), 핸드폰 충전기, 가습기(필요시)를 준비해서 오세요.</p>
                <p>개인 전열기구는 병원에서 사용할 수 없습니다.</p>
                <p>보호자분은 베개, 담요 1개씩만 제공되며, 보호자 슬리퍼는 가지고 오세요. (환자용 슬리퍼는 제공)</p>
                <p>보호자 식사는 제공되지 않습니다. (배달 가능)</p>
                <div class="tw_sub">
                  <span class="pl-15 pb-0"></span>
                </div>
              </div>
            </div>
            <div class="tw_item">
              <div class="tw_title">
                <h2>입원 병실 소개</h2>
              </div>
              <div class="tw_content">
                <p>특실 4실, 1인실 2실, 4인실 2실로 총 14병상을 보유하고 있습니다. 병상수가 적어 선호하는 병실을 항상 맞춰드릴 수 없음을 양해 부탁드립니다.</p>
                <p class="pb-0">병실료 안내</p>
                
                <div class="tw_sub">
                <div class="imgWrap tableImg">
                  <img src="@/assets/images/priceTable.jpg">
                </div>
                </div>
                <!-- <div class="tw_sub">
                  <span class="referMark">1박 병실료: VIP실 23만원, 1인실 19만원, 2인실 15만원</span>
                  <span class="referMark">당일 퇴원 병실료: VIP실 18만원, 1인실 14만원, 2인실 10만원</span>
                </div> -->
                <p class="pb-0">병동 시설</p>
                <div class="tw_sub">
                  <span class="referMark">얼음 정수기, 전자레인지, 냉동고 비치되어 있습니다.</span>
                </div>
                <p class="pb-0">
                  퇴원시간
                </p>
                <div class="tw_sub">
                  <span class="pl-12 pb-0">오전 9시쯤 원장님 진료 및 회진 후 간호사에게 퇴원 안내를 받고 퇴원 가능 합니다.
                  <br/>오전 9시 ~ 9시 30분 이내 퇴원 가능 합니다.
                  </span>
                  <span class="red">(당일 퇴원시 입원한 시각으로부터 6-8시간 뒤 퇴원해야 입원으로 처리됩니다.)</span>
                </div>
                <p>입원 관련하여 필요한 서류가 있으면 미리 말씀해 주십시오. 다만, 조직검사 후 정확한 진단명 기입이 필요한 서류(진단서 등)의 경우에는 수술 1주일 경과 후 조직검사 결과가 나온 후에, 외래에서 서류 신청을 해 주시기 바랍니다.</p>
              </div>
            </div>
            <div class="tw_item">
              <div class="tw_title">
                <h2>주차 안내</h2>
              </div>
              <div class="tw_content another dot">
                <p>승용차 이용시 내비게이션은 "땡큐서울의원"으로 검색하고 오시면 건물 뒷편 주차장 입구('누네안과병원 주차장')가 있습니다. <br/>
                  <a href="https://tv.naver.com/v/31591362" target="_blank" class="red">(참고 영상) &lt; -터치하면 주차 안내 영상이 나옵니다.</a>
                </p>
                <div class="tw_sub">
                  <span class="pl-12 pb-0">선릉역 1번 출구를 지나 -> 우측 버스 정류장을 지나서 -> 우측 공항버스 정류장을 기준으로 우회전 -> 금강타워 주차장 지나서 -> 마디로한의원 기준 우회전(골목으로 들어오세요) -> 누네안과병원 주차장 표지판 확인 후 주차하시면 됩니다. (3호기 승강기를 이용하여 6층 입원실로 내원하세요.)
                  </span>
                </div>
                <p>주차 가능 차량은 길이 5,160mm 이하, 너비 2,050mm 이하, 무게 2,200kg 이하, 높이 SUV/RV 1,850mm 이하로 주차불가 차량들이 있으므로, 사전에 확인하셔야 합니다.  </p>
                <p>주차가 만차가 되거나, 주차 불가될 경우, 인근 유료 주차장인 "테헤란로 64길 노상공영주차장 or 샹제리제센터  B동 주차장" 으로 주차 부탁드립니다.</p>
                <div class="tw_sub">
                  <p>
                    <span class="red">(외부 주차장 사용시 주차비 지원하지 않습니다!)</span>
                  </p>
                </div>
              </div>
            </div>
            <div class="tw_item">
              <div class="tw_title">
                <h2>수술전 주의사항</h2>
                <div class="tw_sub">
                  <span class="red">* 아래 링크를 확인하세요.</span>
                </div>
              </div>
              <div class="tw_content">
                <router-link to="/surgery/beforeCaution">
                  <button>수술전 주의사항</button>
                </router-link>
              </div>
            </div>
            <div class="tw_item last">
              <div class="tw_content another">
                <h4>땡큐서울의원</h4>
                <h4>서울특별시 강남구 테헤란로 408 대치빌딩 4, 5, 6층</h4>
                <h4>선릉역 1번 출구</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
export default {
  data () {
    return {
      transDate: {
        headerName: '입원생활안내',
        prevUrl: '/'
      },
      setCount: false
    }
  },
  created () {
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
  },
  methods: {
    callPrev () {
      if (this.setCount) {
        this.$router.push('/')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    }
  },
  components: {
    AppHeader,
    AppSidebar
  },
  beforeDestroy () {
    this.setCount = false
  }
}
</script>

<style lang="scss" scoped>

.tableImg{width:100%; img{width:100%}}
a.red{color:#ff6565}
</style>
